<template>
    <div>
        <table class="table">
            <tbody>
                <tr>
                    <td class="border-right pr-5">
                        <div class="row mt-3">
                            <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label class="form-label">{{$t('subMenu.salon_menu_product')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-user-cog"></i>
                                            </span>
                                        </div>
                                        <input class="form-control pl-3" :placeholder="$t('subMenu.salon_menu_product')" v-model="selectedProduct[rowID]" required="" @click="show = !show">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label class="form-label text-muted">{{$t('label.selling_price')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control" disabled="" v-model="sellingPrice[rowID]">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 mb-4">
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.unit_price')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input class="form-control product_row_num" type="number" step="any"
                                            :min="unitPrice[rowID]" 
                                            v-model="unitPrice[rowID]" 
                                            @change="calculateTotalByUnitPrice" 
                                            @keydown="isPositiveNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.quantity')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-cart-plus"></i>
                                            </span>
                                        </div>
                                        <input class="form-control product_row_num" type="number" 
                                            :min="minQuantity" 
                                            v-model="quantity[rowID]" 
                                            @change="calculateTotalByQuantity" 
                                            @keydown="isPositiveNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.total')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input class="form-control product_row_num" type="number" step="any"
                                            :min="initialUnit" 
                                            v-model="total[rowID]" 
                                            @change="updateUnitPriceByTotal"
                                            @keydown="isPositiveNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'serSwitch_' + rowID" v-model="autoExpiry[rowID]">
                                <label class="custom-control-label" :for="'serSwitch_' + rowID">{{$t('label.expiry')}}</label>
                            </div>
                        </div>
                        <p v-if="Object.keys(productItems).length != 0 && !isEnable[rowID]" class="error-validation">{{$t('message.error.disabled_item')}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div :class="{'show': show }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title">{{$t('header.list_of', {'item': $t('subMenu.salon_menu_product')})}}</h5>
                        <button type="button" class="close" @click="show = !show">
                            <span><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-5">
                            <div class="col-md-12 col-sm-12">
                                <div class="dataTables_filter mb-2">
                                    <label class="d-flex mb-0">
                                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchProduct" @keypress.enter="searchProductItem">
                                        <button type="button" class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchProductItem()">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </label>
                                </div>
                                <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                            </div>
                        </div>
                        <ul class="nav nav-tabs mb-3" role="tablist">
                            <li class="nav-item border-bottom" v-for="c in productCategory" :key="c.sectionID">
                                <a :class="{'active': selProductCat[rowID] == c.sectionID}" class="nav-link" role="tab" @click="filterCategory(c.sectionID)">{{c.name}}</a>
                            </li>
                        </ul>
                        <div class="demo">
                            <button v-for="s in products" :key="s.skuID" type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed text-left fs-md" @click="selectItem(s.skuID)">
                                <span class="d-block">{{s.name}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-tag mr-2"></i>{{getCategoryText(s.section['sectionID'])}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-dollar-sign mr-3"></i>{{formatPrice(s.price['price'])}} {{$t('label.ea')}}</span>
                            </button>
                            <div class="panel-tag mt-3" v-if="products.length == 0">{{$t('table.no_records')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {isNumber, isPositiveNumber, formatPrice, calculateTotal} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, getCategoryText} from './../../../../assets/js/dashboard/dashboard'
export default {
    name:'packageItemProduct',
    props:{
        rowID: { type: Number },
        productItems: { type: Object }
    },
    data(){
        let itm = {};
        if(this.productItems != undefined){
            itm = Object.assign({}, this.productItems);
        }
        return{
            type: 'product',
            show: false, searchProduct: "",
            categoryList: [],
            productCategory: [], productItem: itm,
            selCat: "all",
            products: [],
            minQuantity: 1, initialUnit: 0,
            packageProductItem:{},
        }
    }, 
    watch:{
        "$i18n.locale"(val){
            this.setCategory()
        }
    },
    computed:{
        selProductCat(){
            var ret = {}
            if(this.productItems != undefined){
                if(Object.keys(this.productItems).length != 0){
                    for(var i=0; i<this.products.length; i++){
                        if(this.productItems.skuID == this.products[i].skuID){
                            ret[this.rowID] = this.products[i].category;
                            break;
                        }
                    }
                }else {
                    ret[this.rowID] = "all";
                }
            }
            return ret;
        },
        selectedProductItemID(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.skuID : 0;
            }
            return ret;
        },
        selectedProductTitle(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.name : "";
            }
            return ret;
        },
        selectedProduct(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.name + " [ " + this.productItems.unitPrice + " ]/ea." : "";
            }
            return ret;
        },
        unitPrice(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.unitPrice : 0;
            }
            return ret;
        },
        quantity(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.quantity : 0;
            }
            return ret;
        },
        total(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.quantity * this.productItems.unitPrice: 0;
            }
            return ret;
        },
        sellingPrice(){
            var ret = {}
            if(this.productItems != undefined){
                if(Object.keys(this.productItems).length != 0){
                    for(var i=0; i<this.products.length; i++){
                        if(this.productItems.skuID == this.products[i].skuID){
                            ret[this.rowID] = formatPrice(this.products[i].price['price']);
                            break;
                        }
                    }
                }else {
                    ret[this.rowID] = 0;
                }
            }
            return ret;
        },
        autoExpiry(){
            var ret = {};
            if(this.productItems != undefined){
                ret[this.rowID] = Object.keys(this.productItems).length != 0 ? this.productItems.autoExpiry : 0;
            }
            return ret;
        },
        isEnable(){
            var ret = {};
            if(this.productItems != undefined){
                if(Object.keys(this.productItems).length != 0 ){
                    ret[this.rowID] = (this.productItems['status'] || {})['enable'] != 1 ? false : true
                }else{
                    ret[this.rowID] = false
                }
            }
            return ret;
        },
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        isPositiveNumber(e) {
            return isPositiveNumber(e);
        },
        formatPrice(price){
            return formatPrice(price);
        },
        getCategoryText(id){
            return (this.categoryList.find(k => k['sectionID'] === id) || {})['name'] || ''
        },

        clearFilter(){
            this.searchProduct = "";
            this.filterCategory("all");
        },
        searchProductItem(){
            this.selCat = "all";
            var strFilter =  this.searchProduct == "" ? "" : "&search=" + this.searchProduct;
            this.getProductItem(strFilter);
        },
        filterCategory(id){
            this.searchProduct = "";
            this.selCat = id;
            var strFilter = this.selCat == "all" ? "" : "&sectionID=" + this.selCat;
            this.getProductItem(strFilter);
        },
        
        async getCategory(){
            let $vm = this;
            let url = 'https://menu.tunai.io/business/sections?typeID=2';

            this.isSpinnerShow = true
            await $vm.$axios({
                method: 'get',
                url: url,
                // baseURL: this.$axios.defaults.baseURL, 
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    this.categoryList = response.data.sections
                    this.productCategory.push({sectionID: "all", name: this.$i18n.t('label.category')});
                    this.productCategory = this.productCategory.concat(...response.data.sections)

                    $vm.getProductItem("")
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        getProductItem(strFilter){
            let queryString = ''

            if(this.selCat !== 'all') {
                let temp = this.categoryList.find(k => k['sectionID'] === this.selCat)
                if(temp['categoryID'] !== -1) {
                    // queryString += '&categoryID=' + temp['categoryID']
                }
                if(temp['sectionID'] !== -1) {
                    queryString += '&sectionID=' + temp['sectionID']
                }
            }

            if(this.searchProduct) {
                queryString += '&search=' + this.searchProduct
            }

            let $vm = this;
            const url =  `https://menu.tunai.io/business/sku?typeID=2&enable=1` + queryString

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.products = response.data.skus;
                $vm.selProductCat[$vm.rowID] = $vm.selCat;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        getPackageProductItem(){
            this.packageProductItem["skuID"] = this.selectedProductItemID[this.rowID];
            this.packageProductItem["itemTitle"] = this.selectedProductTitle[this.rowID];
            this.packageProductItem["quantity"] = this.quantity[this.rowID];
            this.packageProductItem["autoExpiry"] = this.autoExpiry[this.rowID] ? 1 : 0;
            this.packageProductItem["unitPrice"] = this.unitPrice[this.rowID];
            this.packageProductItem["price"] = { price: this.sellingPrice[this.rowID] }
            this.packageProductItem["status"] = { enable: this.isEnable[this.rowID] }

            return this.packageProductItem;
        },
        
        selectItem(id){
            for(var i=0; i<this.products.length; i++){
                if(id == this.products[i].skuID){
                    this.selectedProductItemID[this.rowID] = id;
                    this.selectedProductTitle[this.rowID] = this.products[i].name;
                    this.selectedProduct[this.rowID] = this.selectedProductTitle[this.rowID] + " [ " + this.products[i].price['price'] + " ]/ea.";
                    this.sellingPrice[this.rowID] = formatPrice(this.products[i].price['price']);
                    this.unitPrice[this.rowID] = this.products[i].price['price']
                    this.quantity[this.rowID] = 1
                    this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], this.quantity[this.rowID]);
                    this.isEnable[this.rowID] = (this.products[i].status || {})['enable'] == 1 ? true : false
                    break;
                }
            }
            this.show = false;
            this.selProductCat[this.rowID] = this.selCat;
        },
        calculateTotalByQuantity(e){
            this.quantity[this.rowID] = e.target.value
            this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], this.quantity[this.rowID]);
            this.setTotal();
        },
        calculateTotalByUnitPrice(e){
            this.unitPrice[this.rowID] = e.target.value
            this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], this.quantity[this.rowID]);
            this.setTotal();
        },
        updateUnitPriceByTotal(e){
            this.total[this.rowID] = e.target.value;
            this.unitPrice[this.rowID] = this.total[this.rowID] / this.quantity[this.rowID]

            var row = document.getElementById('productRow_' + this.rowID);
            if(row != null){
                var input = row.getElementsByClassName('product_row_num')
                input[0].value = this.unitPrice[this.rowID]
            }
        },
        setTotal(){
            var row = document.getElementById('productRow_' + this.rowID);
            if(row != null){
                var input = row.getElementsByClassName('product_row_num')
                input[2].value = this.total[this.rowID];
            }
        },
    },
    mounted(){
        let $vm = this;
        $vm.unitPrice[$vm.rowID] = Object.keys($vm.productItem).length != 0 ? $vm.productItem.unitPrice : 0;
        $vm.quantity[$vm.rowID] = Object.keys($vm.productItem).length != 0 ? $vm.productItem.quantity : 1;
        $vm.total[$vm.rowID] = Object.keys($vm.productItem).length != 0 ? $vm.productItem.unitPrice * $vm.productItem.quantity : 0;
        $vm.initialUnit = $vm.unitPrice[$vm.rowID];

        $vm.getCategory()
    }
}
</script>

<style scoped>
.show{ 
    display: block;
}

.nav-link{
    cursor: pointer;
}

.modal-body{
    height: 80vh;
    overflow-y: auto;
}
.error-validation{
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>